import { AxiosError } from "axios";
import { ErrorObject } from "ajv";
import { BrokenRule } from "api";

export const API_RESPONSE_VALIDATION_EXCEPTION_TYPE =
  "System.Runtime.InteropServices.COMException";
export const API_RESPONSE_BROKEN_VALIDATION_EXCEPTION_TYPE =
  "IRM.Validation.BrokenRulesException";

export class ApiStatusException extends Error {
  constructor(message: string, code: number | number[]) {
    super(message);
    this.statusCode = code;
  }

  statusCode: number | number[];
}

export class SchemaValidationError extends Error {
  errors: Partial<ErrorObject>[] | null | undefined;

  constructor(
    message = "Schema validation failed",
    errors?: Partial<ErrorObject>[] | null
  ) {
    super(message);
    this.name = "SchemaValidationError";
    this.errors = errors;
  }
}

export type BrokenRuleValidationError = {
  Detail: string;
  Extensions: { BrokenRules: BrokenRule[] };
  Message: string;
  PropertyName: string;
  Instance: string;
  Status: number;
  Title: string;
  Type: typeof API_RESPONSE_BROKEN_VALIDATION_EXCEPTION_TYPE;
};

export const extractBrokenValidationError = (
  error: AxiosError<BrokenRuleValidationError>
): BrokenRuleValidationError | undefined => error.response?.data;
